import {
  Autocomplete,
  Button,
  Checkbox,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { clone, isEmpty, isNil } from "ramda";
import palette from "../../../../config/colorPalette";
import { ErrorText } from "../styled";
import { useMemo, useState } from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";

const ChannelInfo = ({
  equipments,
  setEquipments,
  selectedEquipment,
  setSelectedEquipment,
  selectedEquipmentID,
  channel,
  indexChannel,
  equipmentInterMeasurement,
  setEquipmentInterMeasurement,
  channelDataToggle,
  setChannelDataToggle,
  zoneToggle,
  setZoneToggle,
  setRealState,
  assetSensors,
  channelsSensorsIDs,
  setchannelSensorsIDs,
  assetSubs,
  setAssetSubs,
  errors,
  setErrors,
  BootstrapButton,
  polylines,
  disabled,
  intl,
}) => {
  const [substructureAsignToggle, setSubstructureAsignToggle] = useState(false);
  const [substructureDataToggle, setSubstructureDataToggle] = useState([]);
  const [substructureSectionToggle, setSubstructureSectionToggle] = useState([]);
  const [substructureSectionDataToggle, setSubstructureSectionDataToggle] = useState([]);

  useMemo(() => {
    const actualLength = selectedEquipment.channels[indexChannel].substructures.length;

    const newSubAsign = [];
    const newSectionAsign = [];
    const newSectionDataAsign = [];
    for (let indexSub = 0; indexSub < actualLength; indexSub++) {
      if (isNil(substructureDataToggle[indexSub])) {
        newSubAsign.push(false);
      } else {
        newSubAsign.push(substructureDataToggle[indexSub]);
      }
      if (
        isNil(substructureSectionToggle[indexSub]) &&
        selectedEquipment.channels[indexChannel].substructures[indexSub].type === "inclinometer"
      ) {
        newSectionAsign.push(false);
      } else if (selectedEquipment.channels[indexChannel].substructures[indexSub].type === "inclinometer") {
        newSectionAsign.push(substructureSectionToggle[indexSub]);
      } else {
        newSectionAsign.push(null);
      }
      newSectionDataAsign.push([]);
      if (
        isNil(substructureSectionDataToggle[indexSub]) &&
        selectedEquipment.channels[indexChannel].substructures[indexSub].type === "inclinometer"
      ) {
        const secCount = selectedEquipment.channels[indexChannel].substructures[indexSub].sections?.length;
        for (let indexSection = 0; indexSection < secCount; indexSection++) {
          newSectionDataAsign[indexSub].push(false);
        }
      } else if (selectedEquipment.channels[indexChannel].substructures[indexSub].type === "inclinometer") {
        const secCount = selectedEquipment.channels[indexChannel].substructures[indexSub].sections.length;
        for (let indexSection = 0; indexSection < secCount; indexSection++) {
          if (isNil(substructureSectionDataToggle[indexSub][indexSection])) {
            newSectionDataAsign[indexSub].push(false);
          } else {
            newSectionDataAsign[indexSub].push(substructureSectionDataToggle[indexSub][indexSection]);
          }
        }
      } else {
        newSectionDataAsign.push(null);
      }
    }
    setSubstructureSectionDataToggle(newSectionDataAsign);
    setSubstructureSectionToggle(newSectionAsign);
    setSubstructureDataToggle(newSubAsign);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Dialog
      maxWidth="lg"
      open={channelDataToggle[indexChannel]}
      onClose={() => {
        let newChannel = clone(channelDataToggle);
        newChannel[indexChannel] = false;
        setChannelDataToggle(newChannel);
      }}
    >
      <DialogTitle style={{ fontSize: "x-large", color: palette.primary, fontWeight: "600" }}>
        {selectedEquipment.channels[indexChannel].name} - {intl.formatMessage({ id: "channel" })} {indexChannel + 1}
      </DialogTitle>
      <DialogContent>
        <div style={{ marginTop: "1%" }}>
          <TextField
            id={`channel_name_${indexChannel}`}
            style={{ margin: "0 0.2rem 0.8rem" }}
            value={channel.name}
            onChange={(e) => {
              const indexEquipment = equipments.findIndex((equipment) => equipment.equipmentID === selectedEquipmentID);

              const newEquipments = [...equipments];
              const updatedEquipment = {
                ...newEquipments[indexEquipment],
                channels: [...newEquipments[indexEquipment].channels],
              };

              updatedEquipment.channels[indexChannel] = {
                ...updatedEquipment.channels[indexChannel],
                name: e.target.value,
              };

              newEquipments[indexEquipment] = updatedEquipment;
              setSelectedEquipment(updatedEquipment);
              setEquipments(newEquipments);
            }}
            error={errors[`channel_name_${indexChannel}`] ? true : false}
            variant="outlined"
            label={intl.formatMessage({ id: "channel.name" })}
            required
            disabled={disabled}
          ></TextField>
          <TextField
            id={`channel_length_${indexChannel}`}
            style={{ margin: "0 0.2rem 0.8rem" }}
            inputProps={{ min: Math.max(...selectedEquipment.channels.map((ch) => ch.info.length)) }}
            value={channel.info.length}
            error={errors[`channel_length_${indexChannel}`] ? true : false}
            variant="outlined"
            label={intl.formatMessage({ id: "channel.length" })}
            type="number"
            required
            disabled={disabled}
            InputLabelProps={{
              shrink: true,
            }}
          ></TextField>
          {selectedEquipment.equipmentType !== "DAS" && (
            <TextField
              id={`channel_spatial_resolution_${indexChannel}`}
              style={{ margin: "0 0.2rem 0.8rem" }}
              inputProps={{ min: 0 }}
              value={channel.info.spatialResolution}
              onChange={(e) => {
                const indexEquipment = equipments.findIndex(
                  (equipment) => equipment.equipmentID === selectedEquipmentID,
                );

                const newEquipments = [...equipments];
                const updatedEquipment = {
                  ...newEquipments[indexEquipment],
                  channels: [...newEquipments[indexEquipment].channels],
                };

                updatedEquipment.channels[indexChannel] = {
                  ...updatedEquipment.channels[indexChannel],
                  info: {
                    ...updatedEquipment.channels[indexChannel].info,
                    spatialResolution: parseFloat(e.target.value),
                  },
                };

                newEquipments[indexEquipment] = updatedEquipment;
                setSelectedEquipment(updatedEquipment);
                setEquipments(newEquipments);
              }}
              error={errors[`channel_spatial_resolution_${indexChannel}`] ? true : false}
              variant="outlined"
              label={intl.formatMessage({ id: "channel.spatial.resolution" })}
              required
              disabled={
                (selectedEquipment.manufacturer !== "Uptech Sensing" &&
                  selectedEquipment.manufacturer !== "AP Sensing") ||
                disabled
              }
              type="number"
              InputLabelProps={{
                shrink: true,
              }}
            ></TextField>
          )}
          <TextField
            id={`channel_sampling_interval_${indexChannel}`}
            style={{ margin: "0 0.2rem 0.8rem" }}
            inputProps={{ min: 0 }}
            value={channel.info.samplingInterval}
            disabled={true}
            error={errors[`channel_sampling_interval_${indexChannel}`] ? true : false}
            variant="outlined"
            label={intl.formatMessage({ id: "channel.sampling.interval" })}
            required
            type="number"
            InputLabelProps={{
              shrink: true,
            }}
          ></TextField>
          {selectedEquipment.equipmentType !== "DAS" && (
            <>
              <TextField
                id={`channel_measurement_time_${indexChannel}`}
                style={{ margin: "0 0.2rem 0.8rem" }}
                inputProps={{ min: 0 }}
                value={channel.measurement.measurementTime}
                onChange={(e) => {
                  const indexEquipment = equipments.findIndex(
                    (equipment) => equipment.equipmentID === selectedEquipmentID,
                  );

                  const newEquipments = [...equipments];
                  const updatedEquipment = {
                    ...newEquipments[indexEquipment],
                    channels: [...newEquipments[indexEquipment].channels],
                  };

                  updatedEquipment.channels[indexChannel] = {
                    ...updatedEquipment.channels[indexChannel],
                    measurement: {
                      ...updatedEquipment.channels[indexChannel].measurement,
                      measurementTime: parseFloat(e.target.value),
                    },
                  };
                  const newErrors = { ...errors };
                  const actualID = selectedEquipmentID + "_frequency";
                  let newSuma = 0;

                  const falseStateChannels = updatedEquipment.channels.reduce((indices, valor, indice) => {
                    if (!valor.state) {
                      indices.push(indice);
                    }
                    return indices;
                  }, []);
                  let auxEquipmentInterMeasurement = equipmentInterMeasurement;
                  for (let indexState = 0; indexState < falseStateChannels.length; indexState++) {
                    if (
                      !isNil(updatedEquipment.channels[falseStateChannels[indexState]].measurement) &&
                      !isNil(updatedEquipment.channels[falseStateChannels[indexState]].measurement.measurementTime)
                    ) {
                      auxEquipmentInterMeasurement =
                        auxEquipmentInterMeasurement -
                        updatedEquipment.channels[falseStateChannels[indexState]].measurement.measurementTime;
                    }
                  }
                  if (
                    isEmpty(updatedEquipment.channels[indexChannel].measurement.measurementInfo) ||
                    isNaN(updatedEquipment.channels[indexChannel].measurement.measurementInfo)
                  ) {
                    newErrors[e.target.id] = "not.empty";
                  } else if (parseFloat(equipmentInterMeasurement) < newSuma) {
                    newErrors[actualID] = "not.higher.than.amount.measurement.time.channels";
                  } else if (parseFloat(equipmentInterMeasurement) > 86400) {
                    newErrors[e.target.id] = "not.higher.than.day";
                  } else {
                    delete newErrors[actualID];
                    delete newErrors[e.target.id];
                  }
                  setErrors(newErrors);
                  newEquipments[indexEquipment] = updatedEquipment;
                  setSelectedEquipment(updatedEquipment);
                  setEquipments(newEquipments);
                  setEquipmentInterMeasurement(auxEquipmentInterMeasurement);
                }}
                error={errors[`channel_measurement_time_${indexChannel}`] ? true : false}
                variant="outlined"
                label={intl.formatMessage({ id: "channel.measurement.time" })}
                required
                disabled={
                  (selectedEquipment.moreInfo.manufacturer !== "Uptech Sensing" &&
                    selectedEquipment.moreInfo.manufacturer !== "AP Sensing") ||
                  disabled
                }
                type="number"
                InputLabelProps={{
                  shrink: true,
                }}
              ></TextField>
              {!isNil(errors[`channel_measurement_time_${indexChannel}`]) && (
                <ErrorText>
                  {intl.formatMessage({
                    id: errors[`channel_measurement_time_${indexChannel}`],
                  })}
                </ErrorText>
              )}
            </>
          )}

          {selectedEquipment.equipmentType === "DAS" && (
            <>
              <TextField
                id={`channel_acquisition_frequency_${indexChannel}`}
                style={{ margin: "0 0.2rem 0.8rem" }}
                defaultValue={0}
                inputProps={{
                  min: 0,
                  max:
                    selectedEquipment.type === "DOUBLE"
                      ? (parseInt(Math.ceil(1 / (2 * (channel.info.length * 1e-8)))) * 0.95) / 2
                      : parseInt(Math.ceil(1 / (2 * (channel.info.length * 1e-8)))) * 0.95,
                }}
                onChange={(e) => {
                  const indexEquipment = equipments.findIndex(
                    (equipment) => equipment.equipmentID === selectedEquipmentID,
                  );

                  const newEquipments = [...equipments];
                  const updatedEquipment = {
                    ...newEquipments[indexEquipment],
                    channels: [...newEquipments[indexEquipment].channels],
                  };

                  updatedEquipment.channels[indexChannel] = {
                    ...updatedEquipment.channels[indexChannel],
                    info: {
                      ...updatedEquipment.channels[indexChannel].info,
                      acquisitionFrequency: parseFloat(e.target.value),
                    },
                  };

                  newEquipments[indexEquipment] = updatedEquipment;
                  setSelectedEquipment(updatedEquipment);
                  setEquipments(newEquipments);
                }}
                error={errors[`channel_acquisition_frequency_${indexChannel}`] ? true : false}
                variant="outlined"
                disabled
                label={intl.formatMessage({ id: "channel.acquisition.frequency" })}
                required
                type="number"
              ></TextField>{" "}
              <TextField
                id={`channel_gauge_length_${indexChannel}`}
                style={{ margin: "0 0.2rem 0.8rem" }}
                defaultValue={0}
                inputProps={{ min: 0 }}
                disabled={disabled}
                onChange={(e) => {
                  const indexEquipment = equipments.findIndex(
                    (equipment) => equipment.equipmentID === selectedEquipmentID,
                  );

                  const newEquipments = [...equipments];
                  const updatedEquipment = {
                    ...newEquipments[indexEquipment],
                    channels: [...newEquipments[indexEquipment].channels],
                  };

                  updatedEquipment.channels[indexChannel] = {
                    ...updatedEquipment.channels[indexChannel],
                    info: {
                      ...updatedEquipment.channels[indexChannel].info,
                      gaugeLength: parseFloat(e.target.value),
                    },
                  };

                  newEquipments[indexEquipment] = updatedEquipment;
                  setSelectedEquipment(updatedEquipment);
                  setEquipments(newEquipments);
                }}
                error={errors[`channel_gauge_length_${indexChannel}`] ? true : false}
                variant="outlined"
                label={intl.formatMessage({ id: "channel.gauge.length" })}
                required
                type="number"
              ></TextField>
            </>
          )}
          <FormControlLabel
            control={
              <Checkbox
                id={"checkbox" + indexChannel}
                sx={{
                  color: palette.primary,
                  "&.Mui-checked": {
                    color: palette.primary,
                  },
                }}
                checked={!channel.state}
                onChange={(e) => {
                  const indexEquipment = equipments.findIndex(
                    (equipment) => equipment.equipmentID === selectedEquipmentID,
                  );

                  const newEquipments = [...equipments];
                  const updatedEquipment = {
                    ...newEquipments[indexEquipment],
                    channels: [...newEquipments[indexEquipment].channels],
                  };

                  updatedEquipment.channels[indexChannel] = {
                    ...updatedEquipment.channels[indexChannel],
                    state: !e.target.checked,
                  };
                  newEquipments[indexEquipment] = updatedEquipment;

                  setRealState(false);
                  setSelectedEquipment(updatedEquipment);
                  setEquipments(newEquipments);
                }}
                disabled={disabled}
              />
            }
            label={intl.formatMessage({ id: "disable?" })}
            style={{ marginLeft: "auto" }}
          />
          {!channel.state ? (
            <TextField
              id={`channel_info_${indexChannel}`}
              style={{ margin: "0 0.2rem 0.8rem" }}
              inputProps={{ min: 0 }}
              value={channel.info.desc}
              onChange={(e) => {
                const indexEquipment = equipments.findIndex(
                  (equipment) => equipment.equipmentID === selectedEquipmentID,
                );

                const newEquipments = [...equipments];
                const updatedEquipment = {
                  ...newEquipments[indexEquipment],
                  channels: [...newEquipments[indexEquipment].channels],
                };

                updatedEquipment.channels[indexChannel] = {
                  ...updatedEquipment.channels[indexChannel],
                  info: {
                    ...updatedEquipment.channels[indexChannel].info,
                    desc: e.target.value,
                  },
                };

                newEquipments[indexEquipment] = updatedEquipment;
                setSelectedEquipment(updatedEquipment);
                setEquipments(newEquipments);
              }}
              disabled={disabled}
              error={errors[`channel_info_${indexChannel}`] ? true : false}
              variant="outlined"
              label={intl.formatMessage({ id: "channel.info" })}
            />
          ) : null}
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          style={{ backgroundColor: palette.secondary, color: "white" }}
          onClick={() => {
            let newChannel = clone(channelDataToggle);
            newChannel[indexChannel] = false;
            setChannelDataToggle(newChannel);
          }}
        >
          {intl.formatMessage({ id: "accept" })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChannelInfo;
